import React from 'react'
import { LeftSearchMenuPiece } from '../search/LeftSearchMenuPiece'
import { Checkbox } from '@deere/ux.uxframe-react'

export const TypeFilter = ({setSelected, types = [], selected = [] }) => {

    const handleTypesCheckBoxChange = event => {
        const code = event.target.id
        if (!selected.includes(code))
            selected.push(code)
        else {
            const index = selected.indexOf(code);
            if(index > - 1) selected.splice(index,1)
        } 
        setSelected([...selected])   
    }

    return (
        <LeftSearchMenuPiece>
            <LeftSearchMenuPiece.Item id="types_filter" title="Type">
                {types.map((t, index) => <Checkbox key={index} label={t.description} id={t.code} onChange={handleTypesCheckBoxChange} />)}
            </LeftSearchMenuPiece.Item>
        </LeftSearchMenuPiece>
    )
}